import { render } from "./studydiffviewer.vue?vue&type=template&id=b8c5fb68&scoped=true"
import script from "./studydiffviewer.js?vue&type=script&lang=js"
export * from "./studydiffviewer.js?vue&type=script&lang=js"

import "./studydiffviewer.vue?vue&type=style&index=0&id=b8c5fb68&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c5fb68"]])

export default __exports__